import React from 'react';

import config from 'config';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Video, useBreakpoint } from '~/techstyle-shared/react-components';

const Wrapper = styled.div`
  width: 100%;
  height: auto;
`;

function VimeoVideo({
  videoId: videoIdObject,
  autopause,
  autopip,
  autoplay,
  background,
  byline,
  color,
  colors,
  controls,
  dnt,
  height,
  interactive_markers: interactiveMarkers,
  interactive_params: interactiveParams,
  keyboard,
  loop,
  maxheight,
  maxwidth,
  muted,
  pip,
  playsinline,
  portrait,
  quality,
  responsive,
  speed,
  texttrack,
  title,
  transcript,
  transparent,
  videoAspectRatio,
  videoTitle = '',
  width,
}) {
  const { isMobile } = useBreakpoint();
  const videoId = isMobile ? videoIdObject?.mobile : videoIdObject?.desktop;
  let aspectRatio = isMobile
    ? videoAspectRatio?.mobile
    : videoAspectRatio?.desktop;
  aspectRatio =
    aspectRatio || config.get('public.brand.defaultVideoAspectRatio');

  const props = {
    aspectRatio,
    autoPlay: autoplay,
    pauseOnViewportLeave: false,
    hasControls: controls,
    isLooping: loop,
    isMuted: muted,
    config: {
      vimeo: {
        title: videoTitle,
        playerOptions: {
          id: videoId,
          autopause,
          autopip,
          autoplay,
          background,
          byline,
          color,
          colors,
          controls,
          dnt,
          height,
          interactive_markers: interactiveMarkers,
          interactive_params: interactiveParams,
          keyboard,
          loop,
          maxheight,
          maxwidth,
          muted,
          pip,
          playsinline,
          portrait,
          quality,
          responsive,
          speed,
          texttrack,
          title,
          transcript,
          transparent,
          width,
        },
      },
    },
  };

  const url = Video.getUrlFromVideoId(videoId);

  if (!videoId || !url) {
    return null;
  }

  return (
    <Wrapper aspectRatio="auto" data-builder-component-type="vimeo">
      <Video url={Video.getUrlFromVideoId(videoId)} {...props} />
    </Wrapper>
  );
}

VimeoVideo.propTypes = {
  autopause: PropTypes.bool,
  autopip: PropTypes.string,
  autoplay: PropTypes.bool,
  background: PropTypes.bool,
  byline: PropTypes.bool,
  color: PropTypes.string,
  colors: PropTypes.string,
  controls: PropTypes.bool,
  dnt: PropTypes.bool,
  height: PropTypes.string,
  interactive_markers: PropTypes.bool,
  interactive_params: PropTypes.string,
  keyboard: PropTypes.bool,
  loop: PropTypes.bool,
  maxheight: PropTypes.string,
  maxwidth: PropTypes.string,
  muted: PropTypes.bool,
  pip: PropTypes.string,
  playsinline: PropTypes.bool,
  portrait: PropTypes.bool,
  quality: PropTypes.string,
  responsive: PropTypes.bool,
  speed: PropTypes.bool,
  texttrack: PropTypes.string,
  title: PropTypes.bool,
  transcript: PropTypes.bool,
  transparent: PropTypes.bool,
  videoAspectRatio: PropTypes.object,
  videoId: PropTypes.object,
  videoTitle: PropTypes.string,
  width: PropTypes.string,
};

export default VimeoVideo;
